<template>
  <div>
    <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8"
      :collapse-action="true">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">General</label>
          <vs-input type="search" placeholder="Search.." v-model="filters['search']" class="w-full" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Date Range</label>
          <v-select :clearable="false" placeholder="" v-model="range_obj" :options="ranges" label="label"
            @input="onChangeRange()" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full" v-if="range_obj.value === 'own_dates'">
          <label class="text-sm opacity-100 text-bold">Date From</label>
          <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full" v-model="filters['from']"
            placeholder="Choose Date From" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full" v-if="range_obj.value === 'own_dates'">
          <label class="text-sm opacity-100 text-bold">Date To</label>
          <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full" v-model="filters['to']"
            placeholder="Choose Date To" />
        </div>
      </div>
    </vx-card>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card class="pt-2">
          <template slot="actions">
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table id="sundry-item-predicted-use-report" :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="items" @sort="handleSort" :sst="true" stripe
              class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="15%" sort-key="purchase_order_code">ORDER CODE</vs-th>
                <vs-th width="15%" sort-key="created_at">ORDER DATE/TIME</vs-th>
                <vs-th width="35%">SUPPLIER</vs-th>
                <vs-th width="15%">REQUIRED BY</vs-th>
                <vs-th width="15%">CREATED BY</vs-th>
                <vs-th width="5%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td class="font-semibold text-primary" :data="data[indextr].purchase_order_code">
                    {{ data[indextr].purchase_order_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].created_at">
                    {{ __dateTimeFormatter(data[indextr].created_at) }}
                  </vs-td>

                  <vs-td :data="data[indextr].supplier">
                    {{ data[indextr].supplier }}
                  </vs-td>

                  <vs-td :data="data[indextr].required_by">
                    {{ data[indextr].required_by }}
                  </vs-td>

                  <vs-td :data="data[indextr].created_by">
                    {{ data[indextr].created_by }}
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip class="mr-2" position="top" text="View Order">
                        <vs-button @click.stop="onClickViewOrder(data[indextr].id)" color="primary" icon="icon-eye"
                          icon-pack="feather" size="small" type="border"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                  <template class="expand-user" slot="expand">
                    <div class="con-expand-users w-full">
                      <h5 class="mx-12 mt-8 mb-2">Order Items</h5>
                      <vs-table :data="tr.items" sort :sst="true" stripe
                        class="table-dark-inverted table-auto vs-con-loading__container mx-12 mb-8">

                        <template slot="thead">
                          <vs-th width="15%">ITEM CODE</vs-th>
                          <vs-th width="30%">ITEM NAME</vs-th>
                          <vs-th width="15%">ITEM STATUS</vs-th>
                          <vs-th width="10%">PRICE (GBP)</vs-th>
                          <vs-th width="15%">QUANTITY (KG)</vs-th>
                          <vs-th width="15%">QTY PENDING TO RECEIVE (KG)</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">

                            <vs-td class="font-semibold text-primary" :data="data[indextr].raw_material_code">
                              {{ data[indextr].raw_material_code }}
                            </vs-td>

                            <vs-td :data="data[indextr].raw_material_name">
                              {{ data[indextr].raw_material_name }}
                            </vs-td>

                            <vs-td :data="data[indextr].item_status">
                              {{ data[indextr].item_status }}
                            </vs-td>

                            <vs-td :data="data[indextr].price">
                              {{ data[indextr].price }}
                            </vs-td>

                            <vs-td :data="data[indextr].quantity">
                              {{ data[indextr].quantity }}
                            </vs-td>

                            <vs-td :data="data[indextr].quantity_pending_to_receive">
                              {{ data[indextr].quantity_pending_to_receive }}
                            </vs-td>

                          </vs-tr>
                        </template>


                      </vs-table>
                    </div>
                  </template>

                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of"
              description-title="Records" description :description-items="descriptionItems"
              :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import moment from "moment";
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { defaultPagination, perPageList } from "@/constants/config";
const InventoryRepository = RepositoryFactory.get('inventory')
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  name: 'ConsumptionReportTable',
  data() {
    return {
      items: [],
      filters: {
        from: '',
        to: ''
      },
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      ranges: [],
      range_obj: {
        value: null
      },
    }
  },
  components: {
    'v-select': vSelect,
    flatPickr,
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  async mounted() {
    this.rangeGenerator()
  },
  methods: {
    async refreshData() {
      this.fetchRmSlowStockReport()
    },
    async fetchRmSlowStockReport() {
      await this.$vs.loading({
        container: '#sundry-item-predicted-use-report',
        scale: 0.45
      })
      try {
        const { data } = await InventoryRepository.getRmItemsConsumptionReportDetails(this.page, this.filterQuery, this.perPage)
        this.items = data.data
        this.meta = data.meta
      } catch (e) {
        this.showWarningMessage('Something went wrong. Please try again!')
      }
      this.$vs.loading.close('#sundry-item-predicted-use-report > .con-vs-loading')
    },
    onClickViewOrder(order_id) {
      const route = this.$router.resolve({ path: `/pages/raw-materials/orders/${order_id}` });
      window.open(route.href, '_blank');
    },
    filterQueryUpdate() {
      this.page = 1
      this.fetchRmSlowStockReport()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchRmSlowStockReport()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchRmSlowStockReport()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    async rangeGenerator() {

      const today = moment().format('DD/MM/YYYY')
      const this_quarter = moment().quarter()

      const start_of_month = moment().startOf('month').format('DD/MM/YYYY');
      const end_of_month = moment().endOf('month').format('DD/MM/YYYY');

      const previous_month_start = moment(today, 'DD/MM/YYYY').subtract(1, 'months').startOf('month').format('DD/MM/YYYY')
      const previous_month_end = moment(today, 'DD/MM/YYYY').subtract(1, 'months').endOf('month').format('DD/MM/YYYY')

      const this_quarter_start = moment().quarter(this_quarter).startOf('quarter').format('DD/MM/YYYY');
      const this_quarter_end = moment().quarter(this_quarter).endOf('quarter').format('DD/MM/YYYY');

      const previous_quarter_start = moment().quarter(this_quarter - 1).startOf('quarter').format('DD/MM/YYYY');
      const previous_quarter_end = moment().quarter(this_quarter - 1).endOf('quarter').format('DD/MM/YYYY');

      const start_of_this_year = moment().startOf('year').format('DD/MM/YYYY');
      const end_of_this_year = moment().endOf('year').format('DD/MM/YYYY');

      const previous_year_start = moment(today, 'DD/MM/YYYY').subtract(1, 'years').startOf('year').format('DD/MM/YYYY')
      const previous_year_end = moment(today, 'DD/MM/YYYY').subtract(1, 'years').endOf('year').format('DD/MM/YYYY')

      this.ranges = [
        { label: 'This Month', value: `${start_of_month} to ${end_of_month}`, key: '30' },
        { label: 'Previous Month', value: `${previous_month_start} to ${previous_month_end}`, key: '60' },
        { label: 'This Quarter', value: `${this_quarter_start} to ${this_quarter_end}`, key: '90' },
        { label: 'Previous Quarter', value: `${previous_quarter_start} to ${previous_quarter_end}`, key: '180' },
        { label: 'This Year', value: `${start_of_this_year} to ${end_of_this_year}`, key: '365' },
        { label: 'Previous Year', value: `${previous_year_start} to ${previous_year_end}`, key: '600' },
        { label: 'Choose Your Own Dates', value: 'own_dates', key: 'own_dates' },
      ]
    },
    async onChangeRange() {
      if (this.range_obj.value !== 'own_dates') {
        let arr = this.range_obj.value.split(' to ')
        this.filters.from = arr[0]
        this.filters.to = arr[1]
        await this.fetchRmSlowStockReport()
      } else {
      }
    },
  },
  watch: {
    page() {
      this.fetchRmSlowStockReport()
    },
    perPage() {
      this.page = 1
      this.fetchRmSlowStockReport()
    }
  }
}
</script>


<style scoped>
.user-edit-popup>>>.vs-popup {
  min-height: 50% !important;
  min-width: 50% !important;
}

@media (min-width: 768px) and (max-width: 1319px) {
  .user-edit-popup>>>.vs-popup {
    min-height: 50% !important;
    min-width: 65% !important;
  }
}
</style>
